export default {
  computed: {
    orders() {
      return [
        {
          type: "lastest",
          label: this.$l10n("LATEST"),
          path: this.$route.path,
          query: { ...this.$route.query, page: 1, order: "lastest" }
        },
        {
          type: "popular",
          label: this.$l10n("POPULAR"),
          path: this.$route.path,
          query: { ...this.$route.query, page: 1, order: "popular" }
        }
      ];
    }
  }
};
